import { useMutation, useQueryClient } from '@tanstack/react-query'

import { PayloadCepIntegration } from 'common/api'
import { showErrorToast } from 'common/api/helpers'
import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { updateCepIntegration } from '../api'

const useUpdateCepIntegration = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      payload,
      integrationId,
    }: {
      payload: PayloadCepIntegration
      integrationId: string
    }) =>
      updateCepIntegration({
        accountId,
        integrationId: integrationId,
        payload,
      }),
    onSuccess: () => {
      successToast('Integration has been successfully updated')
      queryClient.invalidateQueries({
        queryKey: cepIntegrationsKeys.listAccountCepIntegrations(accountId),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useUpdateCepIntegration
